export default __webpack_public_path__ + "static/media/DaylightMediaLogo.35bee404.png";